export default __webpack_public_path__ + "static/media/logo.d0de058f.png";